import React, { useEffect, useContext } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import ManualEntrySubjectList from "modules/Session/ManualEntry/components/ManualEntrySubjectList";
import ManualEntrySubjectPeriodInfo from "modules/Session/ManualEntry/components/ManualEntrySubjectPeriodInfo";
import { BreadcrumbContext } from "Layouts/Header";
import { useGlobalStudy } from "context/StudyContext";
import NoStudySelectedPlaceholder from "Components/Common/NoStudySelectedPlaceholder";

const ManualEntryPage: React.FC = () => {
  document.title = "Manual Entry | ZENTIXS VISTA";
  
  const location = useLocation();
  const breadcrumbContext = useContext(BreadcrumbContext);
  const { selectedStudy: globalStudy } = useGlobalStudy();

  const subjectno = sessionStorage.getItem("subjectno");

  useEffect(() => {
    if (location.pathname.includes("/periods")) {
      breadcrumbContext?.setBreadcrumbItems?.([
        { text: "Manual Entry", link: "/accessioning/manual-entry" },
        { text: `Subject ${subjectno || ""} Periods` },
      ]);
    } else {
      breadcrumbContext?.setBreadcrumbItems?.([
        { text: "Manual Entry" },
      ]);
    }

    return () => breadcrumbContext?.setBreadcrumbItems?.([]);
  }, [location.pathname, subjectno]);

  return (
    <div className="page-content">
      <Container fluid>
        {!globalStudy?.studyid ? (
          <div>
            <NoStudySelectedPlaceholder moduleName="manual entry" />
          </div>
        ) : (
          <Routes>
            <Route
              path="/"
              element={
                <ManualEntrySubjectList />
              }
            />
            <Route
              path="periods"
              element={
                <div>
                  <div className="d-flex align-items-center justify-content-between mb-3 bg-white p-3 rounded shadow-sm">
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="mb-0 fw-semibold text-primary ms-2">
                        Subject No: {subjectno || "—"} - Periods &amp; Time Points
                      </h5>
                    </div>
                  </div>
                  <ManualEntrySubjectPeriodInfo />
                </div>
              }
            />
          </Routes>
        )}
      </Container>
    </div>
  );
};

export default ManualEntryPage;
